import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useTranslation } from 'react-i18next';

export default function OrderSummary({ 
  cart, 
  total, 
  formData 
}) {
  const { t } = useTranslation();

  // Get delivery method display info
  const getDeliveryMethodInfo = () => {
    if (!formData.shipment_details) return null;
    
    const { type, data } = formData.shipment_details;
    
    switch (type) {
      case 'self_pickup':
        return {
          label: t('checkout.delivery.self_pickup'),
          details: data.address,
          cost: data.price,
        };
      case 'cdek_delivery_point':
        return {
          label: t('checkout.delivery.cdek_delivery_point'),
          details: data.deliveryPoint?.name || data.deliveryPoint?.address,
          cost: data.price,
        };
      case 'cdek_courier':
        return {
          label: t('checkout.delivery.cdek_courier'),
          details: data.address,
          cost: data.price,
        };
      default:
        return null;
    }
  };

  const deliveryInfo = getDeliveryMethodInfo();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('checkout.order_summary.title', 'Ваш заказ')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {cart.map((item) => (
            <div key={item.id} className="flex justify-between text-sm">
              <span>{item.name} × {item.cartQuantity}</span>
              <span>₽{(item.price * item.cartQuantity).toLocaleString()}</span>
            </div>
          ))}
          
          {/* Delivery Method Summary */}
          {deliveryInfo && (
            <>
              <Separator className="my-2" />
              <div className="space-y-1">
                <div className="flex justify-between text-sm">
                  <span className="font-medium">{deliveryInfo.label}</span>
                  <span>
                    {deliveryInfo.cost > 0 
                      ? `₽${deliveryInfo.cost.toLocaleString()}`
                      : t('checkout.delivery.free')
                    }
                  </span>
                </div>
                {deliveryInfo.details && (
                  <div className="text-xs text-slate-600 pl-2">
                    {deliveryInfo.details}
                  </div>
                )}
              </div>
            </>
          )}
          
          <Separator className="my-2" />
          <div className="flex justify-between font-bold text-lg">
            <span>{t('checkout.order_summary.total', 'Итого')}:</span>
            <span className="text-amber-600">
              ₽{total.toLocaleString()}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
